/**
 * @generated SignedSource<<d7577d3c1c3741fde67c981d6e990651>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachedContent_products$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedStoreProductItem_StoreProduct">;
  readonly " $fragmentType": "AttachedContent_products";
}>;
export type AttachedContent_products$key = ReadonlyArray<{
  readonly " $data"?: AttachedContent_products$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachedContent_products">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AttachedContent_products",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedStoreProductItem_StoreProduct"
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "7f9a756b218e63bc2d3f08d990e0e863";

export default node;
